import {useMemo} from 'react'

import {useSearchProjectsWithoutArchivedTree} from '../../../hooks/projectTrees'
import {useAppSelector} from '../../../hooks/react-redux'
import {getOverviewData, getOverviewProjectsHash} from '../../../selectors'
import {
  createSearchProjectsTree,
  upgradeSearchProjectsTreeByExpandState,
} from '../../../selectors/projectTrees'
import type {TreeFilter} from '../../../selectors/projectTrees'
import type {ExpandState, ProjectId} from '../../../types'
import {currentServerId} from '../../../types/projectTrees'
import {emptyArray} from '../../../utils/empty'
import type {KeyValue} from '../../../utils/object'

function useDefaultSearchItems(filter: TreeFilter, searchQuery: string) {
  const togglingOverview = useAppSelector(state => state.togglingOverview)
  const overviewData = useAppSelector(getOverviewData)
  const overviewProjectsHash = useAppSelector(getOverviewProjectsHash)
  const defaultTreeWithoutArchived = useSearchProjectsWithoutArchivedTree(filter)
  return useMemo(
    () =>
      createSearchProjectsTree({
        searchQuery,
        defaultTreeByServer: defaultTreeWithoutArchived,
        togglingOverview,
        overviewData,
        overviewProjectsHash,
        federationServers: [],
        parentId: filter.parentId,
      }),
    [
      defaultTreeWithoutArchived,
      filter.parentId,
      overviewData,
      overviewProjectsHash,
      searchQuery,
      togglingOverview,
    ],
  )
}

export function useSearchItems(
  filter: TreeFilter,
  searchQuery: string,
  searchProjectsExpandState: KeyValue<ProjectId, ExpandState> | null | undefined,
) {
  const defaultSearchItems = useDefaultSearchItems(filter, searchQuery)
  return useMemo(
    () => ({
      items:
        upgradeSearchProjectsTreeByExpandState(
          [],
          defaultSearchItems,
          searchProjectsExpandState,
        ).get(currentServerId)?.data ?? emptyArray,
      rootHasReorderedChildren: false,
    }),
    [defaultSearchItems, searchProjectsExpandState],
  )
}
